import { css } from "lit";
// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../components/visually-hidden/index.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[0].use[1]!../../components/button/common.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scan-result {
  display: grid;

  grid-template-areas: "grade data actions";
  grid-template-columns: auto 1fr auto;

  column-gap: var(--spacing);
  justify-content: space-between;

  max-width: var(--max-width);

  padding: var(--spacing);
  margin-bottom: 3rem;

  background-color: var(--color-background-primary);
  border-radius: var(--border-radius);
}

@media (max-width: 1199px) {

.scan-result {
    grid-template-areas: "grade data actions";
    grid-template-columns: auto 1fr auto;

    row-gap: calc(var(--spacing) / 2);
    align-items: flex-start;
    justify-content: space-between;
}
  }

@media (max-width: 991px) {

.scan-result {
    grid-template-areas:
      "grade data   "
      ".     actions";
    grid-template-columns: min-content 1fr;
}
  }

h2 {
  margin-top: 1.5rem;
  margin-bottom: 1rem;

  font-size: 1.375rem;
  font-weight: 600;
}

h2::before {
    display: inline-block;

    content: "";

    background-color: var(--color-text-primary);

    -webkit-mask-repeat: no-repeat;

            mask-repeat: no-repeat;
    -webkit-mask-position: left;
            mask-position: left;
    -webkit-mask-size: contain;
            mask-size: contain;
  }

h2 .host {
    font-weight: 400;
  }

h2.summary::before {
  width: 2rem;
  height: 1.4rem;
  -webkit-mask-image: var(--summary-icon);
          mask-image: var(--summary-icon);
}

h2.result::before {
  width: 2rem;
  height: 1.2rem;
  -webkit-mask-image: var(--results-icon);
          mask-image: var(--results-icon);
}

code {
  font-weight: 600;
}

.grade-trend {
  grid-area: grade;
  justify-self: start;
}

.data {
  grid-area: data;
}

.actions {
  grid-area: actions;
}

.info-tooltip {
  position: relative;

  display: inline-block;

  cursor: pointer;

  background: none;
  border: none;
}

.scan-another {
  margin-top: 1.2rem;
  font-size: var(--type-smaller-font-size);
  font-weight: 400;
}

.scan-another a.button {
    color: var(--button-primary-default);
    background-color: var(--color-background-secondary);
  }

:is(.scan-another a.button):hover {
      color: var(--button-primary-hover);
      -webkit-text-decoration: none;
      text-decoration: none;
      background-color: var(--color-background-secondary);
    }

:is(.scan-another a.button):active {
      color: var(--button-primary-active);
      background-color: var(--color-background-secondary);
    }

.label {
  font-weight: 600;
}

a {
  color: var(--color-text-primary);
  -webkit-text-decoration: none;
  text-decoration: none;
}

a:hover {
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-decoration-color: var(--color-text-secondary);
  }

.grade {
  display: inline-block;

  width: 5rem;
  height: 5rem;

  font-size: 1.7rem;
  font-weight: 600;

  line-height: 5rem;

  color: var(--grade-border);

  text-align: center;

  background: var(--grade-bg);
  border: 1px solid var(--grade-border);
  border-radius: 0.2em;
}

.grade-a {
  --grade-bg: var(--observatory-grade-a-bg);
  --grade-border: var(--observatory-grade-a-border);
}

.grade-b {
  --grade-bg: var(--observatory-grade-b-bg);
  --grade-border: var(--observatory-grade-b-border);
}

.grade-c {
  --grade-bg: var(--observatory-grade-c-bg);
  --grade-border: var(--observatory-grade-c-border);
}

.grade-d {
  --grade-bg: var(--observatory-grade-d-bg);
  --grade-border: var(--observatory-grade-d-border);
}

.grade-f {
  --grade-bg: var(--observatory-grade-f-bg);
  --grade-border: var(--observatory-grade-f-border);
}

.tooltip-popup {
  --tooltip-offset: -6.3rem;
  position: relative;
  inset: unset;
  left: 50%;
  z-index: 1;

  width: max-content;
  max-width: min(100vw, 20rem);

  padding: 1.5rem;
  margin-top: 0.5rem;

  overflow: visible;

  color: var(--observatory-inverse-color-secondary);

  text-align: center;

  background-color: var(--button-primary-default);
  border-width: 0;
  border-radius: var(--border-radius);

  transform: translateX(var(--tooltip-offset));
}

.tooltip-popup .arrow {
    position: absolute;

    padding: 0;
    margin-top: -2rem;
    margin-left: -1rem;

    fill: var(--button-primary-default);
  }

.tooltip-popup table {
    width: 10rem;

    white-space: nowrap;

    border-collapse: collapse;

    border: 0;
  }

:is(.tooltip-popup table) tr {
      font-size: 0.875rem;
      color: var(--observatory-inverse-color-secondary);
    }

.current:is(:is(.tooltip-popup table) tr) {
        color: var(--observatory-inverse-color);
      }

:is(.tooltip-popup table) th,:is(.tooltip-popup table) td {
      width: 50%;

      font-weight: var(--font-body);

      text-align: left;

      background-color: unset;
      border: 0;
    }

:is(.tooltip-popup table) th {
      padding: 0 0 0.75rem;
      font-size: 1rem;
    }

:is(.tooltip-popup table) td {
      padding: 0;
    }

:is(:is(.tooltip-popup table) td) svg {
        vertical-align: -0.3rem;
      }

.scroll-container {
  margin-top: 0.8rem;
  margin-bottom: 1.5rem;

  overflow-x: auto;

  overscroll-behavior-x: none;
}

.footnote {
  margin-top: 1rem;
  font-size: var(--type-smaller-font-size);
}

.detail-header {
  display: flex;
  gap: 0.5rem;
  padding: 0 1.5rem 0 0;
}

.detail-header .arrow {
    color: var(--color-text-secondary);
  }

.detail-header .detail-header-title {
    padding-right: 0.2rem;
    font-weight: 600;
  }

.detail-header p {
    margin: 1rem 0;
  }

:is(.obs-pass-icon svg.pass) path {
      fill: var(--observatory-pass-icon-bg);
    }

:is(.obs-pass-icon svg.pass) circle {
      fill: var(--observatory-pass-icon-color);
    }

:is(.obs-pass-icon svg.fail) path {
      fill: var(--observatory-fail-icon-bg);
    }

:is(.obs-pass-icon svg.fail) circle {
      fill: var(--observatory-fail-icon-color);
    }

.footnote {
  margin-top: 1rem;
  font-size: var(--type-smaller-font-size);
}

.scan-results table {
  min-width: calc(992px - 2rem - 12rem);

  border-collapse: collapse;

  background: var(--observatory-table-bg);
  border: none;
}

:is(.scan-results table) th {
    font-weight: 500;

    vertical-align: top;

    color: var(--color-text-secondary);

    background: var(--observatory-table-header-bg);
  }

:is(.scan-results table) tr:nth-child(odd) {
    background-color: var(--observatory-table-bg-alternate);
  }

:is(.scan-results table) td {
    padding: 0.5rem 1.5rem;
    vertical-align: top;
    overflow-wrap: anywhere;
  }

.cookie-name:is(:is(.scan-results table) td):first-child {
      max-width: 15rem;

      overflow: hidden;
      text-overflow: ellipsis;

      white-space: nowrap;
    }

.score:is(:is(.scan-results table) td) > span {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

:is(.scan-results table) a {
    color: var(--color-text-primary);
    -webkit-text-decoration: underline;
    text-decoration: underline;
    text-decoration-color: var(--color-text-secondary);
  }

:is(:is(.scan-results table) a):hover,:is(:is(.scan-results table) a):active {
      -webkit-text-decoration: none;
      text-decoration: none;
    }

:is(.scan-results table) span.not-counted {
    color: var(--color-text-secondary);
  }

:is(:is(.scan-results table) span.not-counted) a {
      -webkit-text-decoration: none;
      text-decoration: none;
    }

/* Some column width hints on the different result table. */

:is(.tests:is(.scan-results table) th,.tests:is(.scan-results table) td):first-of-type {
        width: 25%;
      }

.tests:is(.scan-results table) td.score {
      white-space: nowrap;
    }

:is(.csp:is(.scan-results table) th,.csp:is(.scan-results table) td):first-of-type {
        width: 45%;
      }

:is(.headers:is(.scan-results table) th,.headers:is(.scan-results table) td):first-of-type {
        width: 30%;
      }

:is(.cookies:is(.scan-results table) th,.cookies:is(.scan-results table) td):nth-of-type(n + 3) {
        text-align: center;
      }

:is(.scan-results table) th,:is(.scan-results table) td {
    padding: 1.5rem;
    border: none;
  }

:is(:is(.scan-results table) th,:is(.scan-results table) td) :first-child {
      margin-top: 0;
    }

:is(:is(.scan-results table) th,:is(.scan-results table) td) :last-child {
      margin-bottom: 0;
    }

:is(.scan-results table) .icon {
    width: 1.3rem;
    height: 1.3rem;
  }

@media (max-width: 425.99px) {
        :is(:is(:is(.scan-results table) td) .iso-date) code {
          font-size: x-small;
        }
  }

@media (max-width: 991.99px) {

.scan-results table {
    /* responsive table */
    min-width: 0;
}

    :is(.scan-results table) thead {
      display: none;
    }

    :is(.scan-results table) tbody {
      display: block;
    }

    :is(.scan-results table) tr {
      display: grid;
      grid-template-columns: max-content auto;
    }

    :is(.scan-results table) tr:nth-of-type(odd) {
      background: var(--observatory-table-header-bg);
    }

    :is(.scan-results table) td {
      display: grid;

      grid-template-columns: subgrid;
      grid-column: span 2;
      grid-auto-flow: column;

      column-gap: 2em;
    }

      :is(:is(.scan-results table) td) .humanized-duration {
        display: none;
      }

    :is(.scan-results table) td::before {
      display: inline;
      font-weight: 600;
      content: attr(data-header);
    }
      :is(.tests:is(.scan-results table),.csp:is(.scan-results table),.headers:is(.scan-results table),.cookies:is(.scan-results table)) td:first-of-type {
        width: auto;
      }

    :is(.scan-results table) td:not(:last-of-type) {
      padding-bottom: 0;
    }

    :is(.scan-results table) td:nth-of-type(n + 2) {
      padding-top: 0.75rem;
    }
      .cookies:is(.scan-results table) td:nth-of-type(n + 3) {
        text-align: left;
      }

    :is(.scan-results table) td.score {
      display: grid;
    }

      :is(:is(.scan-results table) td.score)  > span {
        display: block;
      }

      :is(:is(.scan-results table) td.score) .obs-pass-icon {
        display: inline-block;
        height: 1.5em;
        vertical-align: top;
      }
  }

ol.tabs-list {
  display: grid;

  grid-template-areas:
    "tab-0 tab-1 tab-2 tab-3 tab-4 tab-5 ."
    "hr    hr    hr    hr    hr    hr    hr "
    "mod   mod   mod   mod   mod   mod   mod";
  grid-template-columns: repeat(6, max-content) 1fr;

  column-gap: 3rem;

  padding: 0;
  margin: 0;

  overflow-x: auto;

  overscroll-behavior-x: none;
}

@media (max-width: 991.98px) {

ol.tabs-list {
    grid-template-columns: repeat(6, max-content) auto;
    column-gap: 1.75rem;
}
  }

ol.tabs-list::before {
    grid-area: hr;

    width: 100%;

    margin: 0;

    content: "";

    border: none;
    border-top: 1px solid var(--color-border-primary);
  }

ol.tabs-list input[type="radio"]:not(:checked) ~ .tab-content {
    display: none;
  }

ol.tabs-list li.tabs-list-item {
    display: contents;
  }

:is(ol.tabs-list li.tabs-list-item)  > input:checked + label {
      color: var(--color-text-primary);
      border-bottom: 2px solid var(--observatory-accent);
    }

:is(ol.tabs-list li.tabs-list-item)  > input:not(:checked) + label:hover {
      color: var(--color-text-primary);
      border-bottom: 2px solid var(--observatory-accent-light);
    }

:is(ol.tabs-list li.tabs-list-item)  > input:checked:focus-visible + label {
      outline-style: auto;
      outline-color: var(--accent-primary);
      outline-offset: 1px;
    }

:is(ol.tabs-list li.tabs-list-item)  > input:not(:checked) + label {
      color: var(--color-text-secondary);
      opacity: 0.775;
    }

:is(ol.tabs-list li.tabs-list-item)  > label {
      width: max-content;
      height: 2.2rem;
      cursor: pointer;
    }

#tabs-0:is(ol.tabs-list li.tabs-list-item)  > label,#tabs-0:is(ol.tabs-list li.tabs-list-item)  > input {
        grid-area: tab-0;
      }

#tabs-1:is(ol.tabs-list li.tabs-list-item)  > label,#tabs-1:is(ol.tabs-list li.tabs-list-item)  > input {
        grid-area: tab-1;
      }

#tabs-2:is(ol.tabs-list li.tabs-list-item)  > label,#tabs-2:is(ol.tabs-list li.tabs-list-item)  > input {
        grid-area: tab-2;
      }

#tabs-3:is(ol.tabs-list li.tabs-list-item)  > label,#tabs-3:is(ol.tabs-list li.tabs-list-item)  > input {
        grid-area: tab-3;
      }

#tabs-4:is(ol.tabs-list li.tabs-list-item)  > label,#tabs-4:is(ol.tabs-list li.tabs-list-item)  > input {
        grid-area: tab-4;
      }

#tabs-5:is(ol.tabs-list li.tabs-list-item)  > label,#tabs-5:is(ol.tabs-list li.tabs-list-item)  > input {
        grid-area: tab-5;
      }

:is(ol.tabs-list li.tabs-list-item)  > section.tab-content {
      position: sticky;
      left: 0;

      grid-area: mod;

      margin: 0;
    }

@media (max-width: 991.98px) {

:is(ol.tabs-list li.tabs-list-item)  > section.tab-content {
        width: calc(
          100vw - 12rem - 3rem
        ); /* 12rem: placement width; 3rem: padding */
    }
      }

@media (max-width: 768.98px) {

:is(ol.tabs-list li.tabs-list-item)  > section.tab-content {
        width: calc(100vw - 2rem);
    }
      }
`, "",{"version":3,"sources":["webpack://./observatory/results/results.css"],"names":[],"mappings":"AAGA;EACE,aAAa;;EAEb,yCAAyC;EACzC,oCAAoC;;EAEpC,0BAA0B;EAC1B,8BAA8B;;EAE9B,2BAA2B;;EAE3B,uBAAuB;EACvB,mBAAmB;;EAEnB,iDAAiD;EACjD,mCAAmC;AAiBrC;;AAfE;;AAjBF;IAkBI,yCAAyC;IACzC,oCAAoC;;IAEpC,iCAAiC;IACjC,uBAAuB;IACvB,8BAA8B;AASlC;EARE;;AAEA;;AA1BF;IA2BI;;qBAEiB;IACjB,sCAAsC;AAE1C;EADE;;AAGF;EACE,kBAAkB;EAClB,mBAAmB;;EAEnB,mBAAmB;EACnB,gBAAgB;AAiBlB;;AAfE;IACE,qBAAqB;;IAErB,WAAW;;IAEX,2CAA2C;;IAE3C,8BAAsB;;YAAtB,sBAAsB;IACtB,2BAAmB;YAAnB,mBAAmB;IACnB,0BAAkB;YAAlB,kBAAkB;EACpB;;AAEA;IACE,gBAAgB;EAClB;;AAGF;EACE,WAAW;EACX,cAAc;EACd,uCAA+B;UAA/B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,uCAA+B;UAA/B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,qBAAqB;;EAErB,eAAe;;EAEf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAiBlB;;AAfE;IACE,oCAAoC;IACpC,mDAAmD;EAYrD;;AAVE;MACE,kCAAkC;MAClC,6BAAqB;MAArB,qBAAqB;MACrB,mDAAmD;IACrD;;AAEA;MACE,mCAAmC;MACnC,mDAAmD;IACrD;;AAIJ;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,6BAAqB;EAArB,qBAAqB;AAMvB;;AAJE;IACE,kCAA0B;IAA1B,0BAA0B;IAC1B,kDAAkD;EACpD;;AAGF;EACE,qBAAqB;;EAErB,WAAW;EACX,YAAY;;EAEZ,iBAAiB;EACjB,gBAAgB;;EAEhB,iBAAiB;;EAEjB,0BAA0B;;EAE1B,kBAAkB;;EAElB,2BAA2B;EAC3B,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;;EAEV,kBAAkB;EAClB,4BAA4B;;EAE5B,eAAe;EACf,kBAAkB;;EAElB,iBAAiB;;EAEjB,iDAAiD;;EAEjD,kBAAkB;;EAElB,+CAA+C;EAC/C,eAAe;EACf,mCAAmC;;EAEnC,4CAA4C;AAuD9C;;AArDE;IACE,kBAAkB;;IAElB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;;IAElB,mCAAmC;EACrC;;AAEA;IACE,YAAY;;IAEZ,mBAAmB;;IAEnB,yBAAyB;;IAEzB,SAAS;EAmCX;;AAjCE;MACE,mBAAmB;MACnB,iDAAiD;IAKnD;;AAHE;QACE,uCAAuC;MACzC;;AAGF;MAEE,UAAU;;MAEV,6BAA6B;;MAE7B,gBAAgB;;MAEhB,uBAAuB;MACvB,SAAS;IACX;;AAEA;MACE,oBAAoB;MACpB,eAAe;IACjB;;AAEA;MACE,UAAU;IAKZ;;AAHE;QACE,uBAAuB;MACzB;;AAKN;EACE,kBAAkB;EAClB,qBAAqB;;EAErB,gBAAgB;;EAEhB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AAcvB;;AAZE;IACE,kCAAkC;EACpC;;AAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;AAEA;IACE,cAAc;EAChB;;AAKE;MACE,qCAAqC;IACvC;;AAEA;MACE,wCAAwC;IAC1C;;AAIA;MACE,qCAAqC;IACvC;;AAEA;MACE,wCAAwC;IAC1C;;AAIJ;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,qCAAqC;;EAErC,yBAAyB;;EAEzB,uCAAuC;EACvC,YAAY;AA4Md;;AA1ME;IACE,gBAAgB;;IAEhB,mBAAmB;;IAEnB,kCAAkC;;IAElC,8CAA8C;EAChD;;AAEA;IACE,uDAAuD;EACzD;;AAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EAgBzB;;AAdE;MACE,gBAAgB;;MAEhB,gBAAgB;MAChB,uBAAuB;;MAEvB,mBAAmB;IACrB;;AAEA;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;IAChC;;AAGF;IACE,gCAAgC;IAChC,kCAA0B;IAA1B,0BAA0B;IAC1B,kDAAkD;EAMpD;;AAJE;MAEE,6BAAqB;MAArB,qBAAqB;IACvB;;AAGF;IACE,kCAAkC;EAKpC;;AAHE;MACE,6BAAqB;MAArB,qBAAqB;IACvB;;AAGF,2DAA2D;;AAIvD;QACE,UAAU;MACZ;;AAGF;MACE,mBAAmB;IACrB;;AAME;QACE,UAAU;MACZ;;AAOA;QACE,UAAU;MACZ;;AAOA;QACE,kBAAkB;MACpB;;AAIJ;IAEE,eAAe;IACf,YAAY;EASd;;AAPE;MACE,aAAa;IACf;;AAEA;MACE,gBAAgB;IAClB;;AAGF;IACE,aAAa;IACb,cAAc;EAChB;;AAEA;QAGM;UACE,kBAAkB;QACpB;EAGN;;AAEA;;AApIF;IAqII,qBAAqB;IACrB,YAAY;AA4EhB;;IA1EI;MACE,aAAa;IACf;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,aAAa;MACb,uCAAuC;IACzC;;IAEA;MACE,8CAA8C;IAChD;;IAEA;MACE,aAAa;;MAEb,8BAA8B;MAC9B,mBAAmB;MACnB,sBAAsB;;MAEtB,eAAe;IAKjB;;MAHE;QACE,aAAa;MACf;;IAGF;MACE,eAAe;MACf,gBAAgB;MAChB,0BAA0B;IAC5B;MAME;QACE,WAAW;MACb;;IAGF;MACE,iBAAiB;IACnB;;IAEA;MACE,oBAAoB;IACtB;MAGE;QACE,gBAAgB;MAClB;;IAGF;MACE,aAAa;IAWf;;MATE;QACE,cAAc;MAChB;;MAEA;QACE,qBAAqB;QACrB,aAAa;QACb,mBAAmB;MACrB;EAEJ;;AAGF;EACE,aAAa;;EAEb;;;6CAG2C;EAC3C,iDAAiD;;EAEjD,gBAAgB;;EAEhB,UAAU;EACV,SAAS;;EAET,gBAAgB;;EAEhB,2BAA2B;AAmH7B;;AAjHE;;AAlBF;IAmBI,kDAAkD;IAClD,mBAAmB;AA+GvB;EA9GE;;AAEA;IACE,aAAa;;IAEb,WAAW;;IAEX,SAAS;;IAET,WAAW;;IAEX,YAAY;IACZ,iDAAiD;EACnD;;AAEA;IACE,aAAa;EACf;;AAEA;IACE,iBAAiB;EAyFnB;;AAvFE;MACE,gCAAgC;MAChC,kDAAkD;IACpD;;AAEA;MACE,gCAAgC;MAChC,wDAAwD;IAC1D;;AAEA;MACE,mBAAmB;MACnB,oCAAoC;MACpC,mBAAmB;IACrB;;AAEA;MACE,kCAAkC;MAClC,cAAc;IAChB;;AAEA;MACE,kBAAkB;MAClB,cAAc;MACd,eAAe;IACjB;;AAGE;QAEE,gBAAgB;MAClB;;AAIA;QAEE,gBAAgB;MAClB;;AAIA;QAEE,gBAAgB;MAClB;;AAIA;QAEE,gBAAgB;MAClB;;AAIA;QAEE,gBAAgB;MAClB;;AAIA;QAEE,gBAAgB;MAClB;;AAGF;MACE,gBAAgB;MAChB,OAAO;;MAEP,cAAc;;MAEd,SAAS;IAWX;;AATE;;AARF;QASI;;SAEC,EAAE,0CAA0C;IAMjD;MALE;;AAEA;;AAdF;QAeI,yBAAyB;IAE7B;MADE","sourcesContent":["@import url(\"./../../components/visually-hidden/index.css\");\n@import url(\"./../../components/button/common.css\");\n\n.scan-result {\n  display: grid;\n\n  grid-template-areas: \"grade data actions\";\n  grid-template-columns: auto 1fr auto;\n\n  column-gap: var(--spacing);\n  justify-content: space-between;\n\n  max-width: var(--max-width);\n\n  padding: var(--spacing);\n  margin-bottom: 3rem;\n\n  background-color: var(--color-background-primary);\n  border-radius: var(--border-radius);\n\n  @media (width <= 1199px) {\n    grid-template-areas: \"grade data actions\";\n    grid-template-columns: auto 1fr auto;\n\n    row-gap: calc(var(--spacing) / 2);\n    align-items: flex-start;\n    justify-content: space-between;\n  }\n\n  @media (width <= 991px) {\n    grid-template-areas:\n      \"grade data   \"\n      \".     actions\";\n    grid-template-columns: min-content 1fr;\n  }\n}\n\nh2 {\n  margin-top: 1.5rem;\n  margin-bottom: 1rem;\n\n  font-size: 1.375rem;\n  font-weight: 600;\n\n  &::before {\n    display: inline-block;\n\n    content: \"\";\n\n    background-color: var(--color-text-primary);\n\n    mask-repeat: no-repeat;\n    mask-position: left;\n    mask-size: contain;\n  }\n\n  .host {\n    font-weight: 400;\n  }\n}\n\nh2.summary::before {\n  width: 2rem;\n  height: 1.4rem;\n  mask-image: var(--summary-icon);\n}\n\nh2.result::before {\n  width: 2rem;\n  height: 1.2rem;\n  mask-image: var(--results-icon);\n}\n\ncode {\n  font-weight: 600;\n}\n\n.grade-trend {\n  grid-area: grade;\n  justify-self: start;\n}\n\n.data {\n  grid-area: data;\n}\n\n.actions {\n  grid-area: actions;\n}\n\n.info-tooltip {\n  position: relative;\n\n  display: inline-block;\n\n  cursor: pointer;\n\n  background: none;\n  border: none;\n}\n\n.scan-another {\n  margin-top: 1.2rem;\n  font-size: var(--type-smaller-font-size);\n  font-weight: 400;\n\n  a.button {\n    color: var(--button-primary-default);\n    background-color: var(--color-background-secondary);\n\n    &:hover {\n      color: var(--button-primary-hover);\n      text-decoration: none;\n      background-color: var(--color-background-secondary);\n    }\n\n    &:active {\n      color: var(--button-primary-active);\n      background-color: var(--color-background-secondary);\n    }\n  }\n}\n\n.label {\n  font-weight: 600;\n}\n\na {\n  color: var(--color-text-primary);\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n    text-decoration-color: var(--color-text-secondary);\n  }\n}\n\n.grade {\n  display: inline-block;\n\n  width: 5rem;\n  height: 5rem;\n\n  font-size: 1.7rem;\n  font-weight: 600;\n\n  line-height: 5rem;\n\n  color: var(--grade-border);\n\n  text-align: center;\n\n  background: var(--grade-bg);\n  border: 1px solid var(--grade-border);\n  border-radius: 0.2em;\n}\n\n.grade-a {\n  --grade-bg: var(--observatory-grade-a-bg);\n  --grade-border: var(--observatory-grade-a-border);\n}\n\n.grade-b {\n  --grade-bg: var(--observatory-grade-b-bg);\n  --grade-border: var(--observatory-grade-b-border);\n}\n\n.grade-c {\n  --grade-bg: var(--observatory-grade-c-bg);\n  --grade-border: var(--observatory-grade-c-border);\n}\n\n.grade-d {\n  --grade-bg: var(--observatory-grade-d-bg);\n  --grade-border: var(--observatory-grade-d-border);\n}\n\n.grade-f {\n  --grade-bg: var(--observatory-grade-f-bg);\n  --grade-border: var(--observatory-grade-f-border);\n}\n\n.tooltip-popup {\n  --tooltip-offset: -6.3rem;\n  position: relative;\n  inset: unset;\n  left: 50%;\n  z-index: 1;\n\n  width: max-content;\n  max-width: min(100vw, 20rem);\n\n  padding: 1.5rem;\n  margin-top: 0.5rem;\n\n  overflow: visible;\n\n  color: var(--observatory-inverse-color-secondary);\n\n  text-align: center;\n\n  background-color: var(--button-primary-default);\n  border-width: 0;\n  border-radius: var(--border-radius);\n\n  transform: translateX(var(--tooltip-offset));\n\n  .arrow {\n    position: absolute;\n\n    padding: 0;\n    margin-top: -2rem;\n    margin-left: -1rem;\n\n    fill: var(--button-primary-default);\n  }\n\n  table {\n    width: 10rem;\n\n    white-space: nowrap;\n\n    border-collapse: collapse;\n\n    border: 0;\n\n    tr {\n      font-size: 0.875rem;\n      color: var(--observatory-inverse-color-secondary);\n\n      &.current {\n        color: var(--observatory-inverse-color);\n      }\n    }\n\n    th,\n    td {\n      width: 50%;\n\n      font-weight: var(--font-body);\n\n      text-align: left;\n\n      background-color: unset;\n      border: 0;\n    }\n\n    th {\n      padding: 0 0 0.75rem;\n      font-size: 1rem;\n    }\n\n    td {\n      padding: 0;\n\n      svg {\n        vertical-align: -0.3rem;\n      }\n    }\n  }\n}\n\n.scroll-container {\n  margin-top: 0.8rem;\n  margin-bottom: 1.5rem;\n\n  overflow-x: auto;\n\n  overscroll-behavior-x: none;\n}\n\n.footnote {\n  margin-top: 1rem;\n  font-size: var(--type-smaller-font-size);\n}\n\n.detail-header {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0 1.5rem 0 0;\n\n  .arrow {\n    color: var(--color-text-secondary);\n  }\n\n  .detail-header-title {\n    padding-right: 0.2rem;\n    font-weight: 600;\n  }\n\n  p {\n    margin: 1rem 0;\n  }\n}\n\n.obs-pass-icon {\n  svg.pass {\n    path {\n      fill: var(--observatory-pass-icon-bg);\n    }\n\n    circle {\n      fill: var(--observatory-pass-icon-color);\n    }\n  }\n\n  svg.fail {\n    path {\n      fill: var(--observatory-fail-icon-bg);\n    }\n\n    circle {\n      fill: var(--observatory-fail-icon-color);\n    }\n  }\n}\n\n.footnote {\n  margin-top: 1rem;\n  font-size: var(--type-smaller-font-size);\n}\n\n.scan-results table {\n  min-width: calc(992px - 2rem - 12rem);\n\n  border-collapse: collapse;\n\n  background: var(--observatory-table-bg);\n  border: none;\n\n  th {\n    font-weight: 500;\n\n    vertical-align: top;\n\n    color: var(--color-text-secondary);\n\n    background: var(--observatory-table-header-bg);\n  }\n\n  tr:nth-child(odd) {\n    background-color: var(--observatory-table-bg-alternate);\n  }\n\n  td {\n    padding: 0.5rem 1.5rem;\n    vertical-align: top;\n    overflow-wrap: anywhere;\n\n    &.cookie-name:first-child {\n      max-width: 15rem;\n\n      overflow: hidden;\n      text-overflow: ellipsis;\n\n      white-space: nowrap;\n    }\n\n    &.score > span {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n    }\n  }\n\n  a {\n    color: var(--color-text-primary);\n    text-decoration: underline;\n    text-decoration-color: var(--color-text-secondary);\n\n    &:hover,\n    &:active {\n      text-decoration: none;\n    }\n  }\n\n  span.not-counted {\n    color: var(--color-text-secondary);\n\n    a {\n      text-decoration: none;\n    }\n  }\n\n  /* Some column width hints on the different result table. */\n  &.tests {\n    th,\n    td {\n      &:first-of-type {\n        width: 25%;\n      }\n    }\n\n    td.score {\n      white-space: nowrap;\n    }\n  }\n\n  &.csp {\n    th,\n    td {\n      &:first-of-type {\n        width: 45%;\n      }\n    }\n  }\n\n  &.headers {\n    th,\n    td {\n      &:first-of-type {\n        width: 30%;\n      }\n    }\n  }\n\n  &.cookies {\n    th,\n    td {\n      &:nth-of-type(n + 3) {\n        text-align: center;\n      }\n    }\n  }\n\n  th,\n  td {\n    padding: 1.5rem;\n    border: none;\n\n    :first-child {\n      margin-top: 0;\n    }\n\n    :last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  .icon {\n    width: 1.3rem;\n    height: 1.3rem;\n  }\n\n  @media (width <= 425.99px) {\n    td {\n      .iso-date {\n        code {\n          font-size: x-small;\n        }\n      }\n    }\n  }\n\n  @media (width <= 991.99px) {\n    /* responsive table */\n    min-width: 0;\n\n    thead {\n      display: none;\n    }\n\n    tbody {\n      display: block;\n    }\n\n    tr {\n      display: grid;\n      grid-template-columns: max-content auto;\n    }\n\n    tr:nth-of-type(odd) {\n      background: var(--observatory-table-header-bg);\n    }\n\n    td {\n      display: grid;\n\n      grid-template-columns: subgrid;\n      grid-column: span 2;\n      grid-auto-flow: column;\n\n      column-gap: 2em;\n\n      .humanized-duration {\n        display: none;\n      }\n    }\n\n    td::before {\n      display: inline;\n      font-weight: 600;\n      content: attr(data-header);\n    }\n\n    &.tests,\n    &.csp,\n    &.headers,\n    &.cookies {\n      td:first-of-type {\n        width: auto;\n      }\n    }\n\n    td:not(:last-of-type) {\n      padding-bottom: 0;\n    }\n\n    td:nth-of-type(n + 2) {\n      padding-top: 0.75rem;\n    }\n\n    &.cookies {\n      td:nth-of-type(n + 3) {\n        text-align: left;\n      }\n    }\n\n    td.score {\n      display: grid;\n\n      > span {\n        display: block;\n      }\n\n      .obs-pass-icon {\n        display: inline-block;\n        height: 1.5em;\n        vertical-align: top;\n      }\n    }\n  }\n}\n\nol.tabs-list {\n  display: grid;\n\n  grid-template-areas:\n    \"tab-0 tab-1 tab-2 tab-3 tab-4 tab-5 .\"\n    \"hr    hr    hr    hr    hr    hr    hr \"\n    \"mod   mod   mod   mod   mod   mod   mod\";\n  grid-template-columns: repeat(6, max-content) 1fr;\n\n  column-gap: 3rem;\n\n  padding: 0;\n  margin: 0;\n\n  overflow-x: auto;\n\n  overscroll-behavior-x: none;\n\n  @media (width <= 991.98px) {\n    grid-template-columns: repeat(6, max-content) auto;\n    column-gap: 1.75rem;\n  }\n\n  &::before {\n    grid-area: hr;\n\n    width: 100%;\n\n    margin: 0;\n\n    content: \"\";\n\n    border: none;\n    border-top: 1px solid var(--color-border-primary);\n  }\n\n  input[type=\"radio\"]:not(:checked) ~ .tab-content {\n    display: none;\n  }\n\n  li.tabs-list-item {\n    display: contents;\n\n    > input:checked + label {\n      color: var(--color-text-primary);\n      border-bottom: 2px solid var(--observatory-accent);\n    }\n\n    > input:not(:checked) + label:hover {\n      color: var(--color-text-primary);\n      border-bottom: 2px solid var(--observatory-accent-light);\n    }\n\n    > input:checked:focus-visible + label {\n      outline-style: auto;\n      outline-color: var(--accent-primary);\n      outline-offset: 1px;\n    }\n\n    > input:not(:checked) + label {\n      color: var(--color-text-secondary);\n      opacity: 0.775;\n    }\n\n    > label {\n      width: max-content;\n      height: 2.2rem;\n      cursor: pointer;\n    }\n\n    &#tabs-0 {\n      > label,\n      > input {\n        grid-area: tab-0;\n      }\n    }\n\n    &#tabs-1 {\n      > label,\n      > input {\n        grid-area: tab-1;\n      }\n    }\n\n    &#tabs-2 {\n      > label,\n      > input {\n        grid-area: tab-2;\n      }\n    }\n\n    &#tabs-3 {\n      > label,\n      > input {\n        grid-area: tab-3;\n      }\n    }\n\n    &#tabs-4 {\n      > label,\n      > input {\n        grid-area: tab-4;\n      }\n    }\n\n    &#tabs-5 {\n      > label,\n      > input {\n        grid-area: tab-5;\n      }\n    }\n\n    > section.tab-content {\n      position: sticky;\n      left: 0;\n\n      grid-area: mod;\n\n      margin: 0;\n\n      @media (width <= 991.98px) {\n        width: calc(\n          100vw - 12rem - 3rem\n        ); /* 12rem: placement width; 3rem: padding */\n      }\n\n      @media (width <= 768.98px) {\n        width: calc(100vw - 2rem);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default css([___CSS_LOADER_EXPORT___.toString()]);
